export default __webpack_public_path__ + "static/media/bladeIcon.fa1c43ff.svg";